import { TranslateService } from '@ngx-translate/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import { ChartFiltersService } from '../../../@core/utils';

import { FormsModule } from '@angular/forms';
import { NbRadioModule } from '@nebular/theme';

@Component({
    selector: 'app-investments-status-filter',
    templateUrl: './investments-status-filter.component.html',
    styleUrls: ['./investments-status-filter.component.scss'],
    standalone: true,
    imports: [NbRadioModule, FormsModule]
})
export class InvestmentsStatusFilterComponent implements OnInit, OnDestroy {

  public investmentsStatusFilterOptions = [
    {
      value: KPI.InvestmentsStatusFilter.ALL_INVESTMENTS,
      label: this.translate.instant('All investments'),
    },
    {
      value: KPI.InvestmentsStatusFilter.ONLY_PLANNED,
      label: this.translate.instant('Planned only'),
    },
    {
      value: KPI.InvestmentsStatusFilter.ONLY_HYPOTHESIS,
      label: this.translate.instant('Only hypothesis invest'),
    },
  ];

  private subscriptions: Subscription[] = [];
  public investmentsStatusFilter: number;

  constructor(
    private translate: TranslateService,
    private chartFiltersService: ChartFiltersService
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.chartFiltersService.filter$('investmentsStatus', true).pipe(
        first()
      ).subscribe((investmentsStatusFilter) => {
        this.investmentsStatusFilter = <number>investmentsStatusFilter;
      }),
    );
  }

  public investmentsStatusFilterChanged(): void {
    setTimeout(() => {
      this.chartFiltersService.setFilter('investmentsStatus', this.investmentsStatusFilter);
    }, 50);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
